import { userAxios } from '../index'

const getData = async data => {
  try {
    return await userAxios.post(`dashboard/get-data`, data).then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const getDataAll = async data => {
  try {
    return await userAxios.post(`dashboard/all-data`, data).then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const getAllDashboardData = async data => {
  try {
    const [
      allDataCount,
      allPatients,
      allPatientsByInsurance,
      totalRefunds,
      yearData,
      bonus,
      valuesTotals,
    ] = await Promise.all([
      userAxios.post(`dashboard/all-data-patients-count`, data).then(res => res.data),
      userAxios.post(`dashboard/all-data-patients`, data).then(res => res.data),
      userAxios
        .post(`dashboard/all-data-patients-by-insurance`, data)
        .then(res => res.data),
      userAxios.post(`dashboard/all-data-total-refounds`, data).then(res => res.data),
      userAxios.post(`dashboard/all-data-year-data`, data).then(res => res.data),
      userAxios.post(`dashboard/all-data-bonus`, data).then(res => res.data),
      userAxios.post(`dashboard/all-values-totals`, data).then(res => res.data),
    ])

    return {
      allDataCount: allDataCount,
      all_patients: allPatients,
      all_patients_by_insurance: allPatientsByInsurance,
      total_refunds: totalRefunds,
      year_data: yearData,
      bonus: bonus,
      values_totals: valuesTotals,
    }
  } catch (error) {
    console.error('Error fetching dashboard data:', error)
    throw error
  }
}

const cashView = async id => {
  try {
    return await userAxios.get(`cashControl/${id}`).then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const cashGlobalClose = async data => {
  try {
    return await userAxios
      .post(`cashControl/clinicCash/closing`, data)
      .then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const cashGlobalDaily = async () => {
  try {
    return await userAxios.get(`cashControl/admin`).then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const cashGlobalHistory = async (id, perPage) => {
  try {
    return await userAxios
      .get(`cashControl/admin/clinic/${id}/${perPage}`)
      .then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const attachFile = async data => {
  try {
    return await userAxios
      .post(`cashControl/clinicCash/attach`, data)
      .then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

export default {
  getData,
  getDataAll,
  getAllDashboardData,
}
